import { ContentCopy, Download, QrCode2Outlined } from "@mui/icons-material";
import { Box, Button, IconButton, InputAdornment, TextField, Tooltip, Typography } from "@mui/material";
import { useDownload } from "../../../../../core/hooks/useDownload";
import { useCopiar } from "../../../../../core/hooks/useCopiar";
import { useRef } from "react";
import * as htmlToImage from 'html-to-image';
import { IMarketplace } from "../../../../interfaces/IMarketplace";
import QRCode from "qrcode.react";
import { useSnackbar } from "../../../../../core/contexts/SnackbarContext";
import { SecaoConfiguracao } from "../../../../../core/components/SecaoConfiguracao";

interface QRCodeMarketplacePaperProps {
    marketplace: IMarketplace;
}

export const QRCodeMarketplacePaper = ({ marketplace }: QRCodeMarketplacePaperProps) => {
    const { downloadPorUrl } = useDownload();
    const copiar = useCopiar(
        marketplace?.configuracao?.urlExterna ?? "Link não mapeado",
        "Link copiado para a área de transferência!"
    );

    const qrCodeRef = useRef(null);
    const snackbar = useSnackbar();

    const handleDownloadQRCode = () => {
        if (qrCodeRef.current && marketplace?.configuracao?.slug) {
            htmlToImage.toPng(qrCodeRef.current)
                .then((dataUrl) => {
                    downloadPorUrl(dataUrl, `${marketplace?.configuracao?.slug}.png`);
                })
                .catch((error) => {
                    snackbar('Ocorreu um erro ao fazer o download do QR Code', { severity: "error" });
                });
        }
    }

    return (
        <SecaoConfiguracao
            titulo="Link público e QR Code"
            descricao="Compartilhe o acesso ao seu cardápio online"
            icone={<QrCode2Outlined />}
            acoes={
                <Tooltip title="Baixar QR Code em PNG">
                    <Button onClick={handleDownloadQRCode} size="small" startIcon={<Download />} variant="outlined">
                        Download
                    </Button>
                </Tooltip>
            }
        >
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, flex: 1, justifyContent: "center" }}>
                {marketplace?.configuracao?.urlExterna ? (
                    <Box
                        sx={{
                            p: 2,
                            borderRadius: "16px",
                            backgroundColor: "#FFF",
                            border: theme => `1px solid ${theme.palette.divider}`,
                            display: "flex"
                        }}
                    >
                        <div ref={qrCodeRef}>
                            <QRCode value={marketplace?.configuracao?.urlExterna} />
                        </div>
                    </Box>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        Nenhum link público mapeado para este marketplace
                    </Typography>
                )}
                <TextField
                    label="Link público"
                    disabled
                    size="small"
                    value={marketplace.configuracao?.urlExterna ?? "Link não mapeado"}
                    fullWidth
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <Tooltip title="Copiar link">
                                    <IconButton onClick={copiar} size="small">
                                        <ContentCopy fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </InputAdornment>
                        ),
                    }}
                    InputLabelProps={{
                        shrink: true
                    }}
                />
            </Box>
        </SecaoConfiguracao>
    );
}
